import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (pathname === "/") {
        const homeSection = document.getElementById("home-section");
        if (homeSection) {
          homeSection.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100); // Small delay to ensure correct scroll position

  }, [pathname]);

  return null;
};

export default ScrollToTop;
